module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Extralight.a4abd52e.woff2";